import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ENVIRONMENT_INITIALIZER, inject, ModuleWithProviders, NgModule } from '@angular/core';

import { Persist } from '../storage/persist.model';
import { AuthTokenInterceptor } from './auth-token.interceptor';
import { AuthRefreshTokenInterceptor } from './auth-token/auth-refresh-token.interceptor';
import { AuthSessionGuardInit } from './auth-token/auth-session.guard';
import { AUTH_PERSIST, AuthService } from './auth.service';

const AUTH_STORAGE = 'AUTH_STORAGE';

@NgModule()
export class CommonAuthModule {
  static forRoot(): ModuleWithProviders<CommonAuthModule> {
    return {
      ngModule: CommonAuthModule,
      providers: [
        { provide: AUTH_PERSIST, useFactory: () => new Persist(AUTH_STORAGE) },
        AuthService,
        {
          provide: ENVIRONMENT_INITIALIZER,
          useValue: () => inject(AuthService).init(),
          multi: true,
        },
        { provide: HTTP_INTERCEPTORS, useClass: AuthRefreshTokenInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: AuthTokenInterceptor, multi: true },
        {
          provide: ENVIRONMENT_INITIALIZER,
          useValue: AuthSessionGuardInit,
          multi: true,
        },
      ],
    };
  }
}
